export default __webpack_public_path__ + "static/usman-portrait-dd6edba35bfd8825ec400ef3fa097a77.jpg";